import React, { useState } from "react";
import { SwipeableDrawer, Typography, Box } from "@mui/material";
import Button from "../Button/Button";
import ContactUsForm from "../../contactUs/ContactUsForm";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function BottomContactUsFormModal({ open, toggleDrawer, contactModalType }) {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={() => toggleDrawer(false)}
      ModalProps={{
        keepMounted: true,
      }}
      PaperProps={{
        sx: {
          minHeight: "100%",
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box
        sx={{
          display: {
            xs: "block",
            sm: "none",
          },
          marginLeft: "16px",
          marginTop: "28px",
        }}
      >
        <ArrowBackIcon sx={{ color: "primary.main" }} />
      </Box>
      <ContactUsForm contactModalType={contactModalType} />
      <Button
        variant="standard"
        size="lg"
        txColor="primary.main"
        sx={{
          height: "max-content",
          width: { xs: "100%", sm: "336px" },
          boxShadow: "none",
        }}
        onClick={() => {
          toggleDrawer(false);
        }}
      >
        Cancel
      </Button>
    </SwipeableDrawer>
  );
}

export default BottomContactUsFormModal;
